/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbRespFollowSearchBanner_user$ref = any;
type SbRespFollowSearchTopButton_user$ref = any;
type SbRespMainContent_user$ref = any;
type SbRespNullSearchResults_user$ref = any;
type SbSharedFollowSearchProvider_user$ref = any;
type SharedRecentlyViewedItems_user$ref = any;
type SuspectedTradeUserLoader_user$ref = any;
type TradePromo_user$ref = any;
export type SbRespComponents_user$ref = any;
export type SbRespComponents_user = {
    readonly " $fragmentRefs": TradePromo_user$ref & SbRespNullSearchResults_user$ref & SbRespFollowSearchBanner_user$ref & SbRespFollowSearchTopButton_user$ref & SbSharedFollowSearchProvider_user$ref & SharedRecentlyViewedItems_user$ref & SbRespMainContent_user$ref & SuspectedTradeUserLoader_user$ref;
    readonly " $refType": SbRespComponents_user$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespComponents_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "TradePromo_user",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespNullSearchResults_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchBanner_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespFollowSearchTopButton_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedFollowSearchProvider_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SharedRecentlyViewedItems_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespMainContent_user",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SuspectedTradeUserLoader_user",
      "args": null
    }
  ]
};
(node as any).hash = 'b23dbdd8e8332b0dc98e23a52b11a8c9';
export default node;
